import React, { FC } from 'react';

import styles from './label-header.module.sass';

export const LabelHeader: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({
                                                                                                                   className,
                                                                                                                   ...props
                                                                                                                 }) => {
  return <span {...props} className={`${styles.header} label-header ${className ?? ''}`}>
    {props.children}
  </span>;
};
